export type LogInFormFields = {
  username: string;
  password: string;
};

export type RegisterFormFields = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  optedInToSembonus: boolean;
  optedInNewsletter: boolean;
};

export type ResetPasswordFormFields = {
  email: string;
};

export const performLogIn = async ({ username, password }: LogInFormFields) =>
  fetch('/d/mvc/authenticate/login', {
    body: JSON.stringify({ username, password }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

export const performRegister = ({
  firstName,
  lastName,
  email,
  password,
  confirmPassword,
  optedInToSembonus,
}: RegisterFormFields) =>
  fetch(`/d/mvc/Members/Signup`, {
    body: JSON.stringify({
      firstName,
      lastName,
      email,
      password,
      confirmPassword,
      optedInToSembonus,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    credentials: 'include',
  });

export const performSubscribeNewsletter = ({
  firstName,
  lastName,
  email,
}: RegisterFormFields) =>
  fetch(`/d/mvc/subscribetonewsletter/subscribe`, {
    body: JSON.stringify({
      firstName,
      lastName,
      email,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    credentials: 'include',
  });

export const performResetPassword = async ({
  email,
}: ResetPasswordFormFields) => {
  const form = new FormData();
  form.append(
    'ctl00$ctl00$ctl00$BodyContentPlaceHolder$BodyContentPlaceHolder$MainContentPlaceHolder$EmailAddressTextBox',
    email
  );
  form.append(
    'ctl00$ctl00$ctl00$BodyContentPlaceHolder$BodyContentPlaceHolder$MainContentPlaceHolder$SendMailButton',
    'Send'
  );
  form.append('__EVENTTARGET', '');

  const options = {
    method: 'POST',
    body: form,
  };

  return fetch('/d/RequestPassword.aspx', options);
};
